<template>
  <div class="coming-soon">
    <div class="coming-soon-icon">👨‍🏫</div>
    <h2 class="coming-soon-title">教职工名录</h2>
    <p class="coming-soon-text">
      本部分将收录东亚同文书院历任教职工的详细信息，包括教学领域、任职时间及相关学术成果。
      资料整理中，敬请期待！
    </p>
  </div>
</template>

<script>
export default {
  name: 'Faculty'
}
</script>

<style scoped>
.coming-soon {
  text-align: center;
  padding: 50px 20px;
}

.coming-soon-icon {
  font-size: 5rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.coming-soon-title {
  font-size: 1.8rem;
  color: var(--primary-dark);
  margin-bottom: 15px;
}

.coming-soon-text {
  font-size: 1.1rem;
  color: var(--secondary-color);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .coming-soon-icon {
    font-size: 3.5rem;
  }

  .coming-soon-title {
    font-size: 1.5rem;
  }

  .coming-soon-text {
    font-size: 1rem;
  }
}
</style>